export default "__VITE_ASSET__DC0WWw3I__"